import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import {
  getMedicamentosPermitidosDeEmpadronamiento,
  postMedicamentosMedicacion,
  setActiveStep
} from "../../../actions/empadronamiento/Empadronamiento";
import {
  STEPPER_MEDICACION
} from "../../../utils/constants";
import { MedicacionCard } from "../UI/MedicacionCard";
import { MedicacionAddMedicamento } from "./MedicacionAddMedicamento";
import { MedicacionMedicamento } from "./MedicacionMedicamento";
import AlertaMedicamento from "../UI/AlertaMedicamento";
//import { Redirect } from "react-router-dom";

export const MedicacionMedicamentos = (props) => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const { medicamentos = [], solicitudSeleccionada = {}, medicamentosDeEmpadronamiento = [] } = useSelector(
    (state) => state.empadronamiento
  );

  const avanzarPantalla = () => {
    dispatch(setActiveStep(STEPPER_MEDICACION.CONFIRMACION));
  };

  useEffect(() => {
    dispatch(getMedicamentosPermitidosDeEmpadronamiento(solicitudSeleccionada?.idSolicitudEmp));
  }, [solicitudSeleccionada]);

  const onConfirmHandler = () => {
    const medicamentosFormateados = medicamentos.map((medicamento) => {
      return {
        idSolicitud: solicitudSeleccionada.idSolicitud,
        idMedicamento: medicamento.idMedicamento,
        cantidad: medicamento.cantidad,
        dosis: medicamento.dosis,
        posologia: medicamento.posologia,
        surge: medicamento.surge,
        idConvenioSC: medicamento.idConvenioSC,
        idTipoEmpadronamiento: solicitudSeleccionada.idTipoEmpadronamiento,
      };
    });

    dispatch(postMedicamentosMedicacion({ medicamentos: medicamentosFormateados }, avanzarPantalla));
  };

  const onClickSiguienteHandler = () => {
    var medicamentosValidos = true;
    var mensajeString = "";
    var drogas = "";
    setMensaje("");

    const medicamentosFormateados = medicamentos.map((medicamento) => {
      return {
        idSolicitud: solicitudSeleccionada.idSolicitud,
        idMedicamento: medicamento.idMedicamento,
        cantidad: medicamento.cantidad,
        dosis: medicamento.dosis,
        posologia: medicamento.posologia,
        surge: medicamento.surge,
        idConvenioSC: medicamento.idConvenioSC,
        idTipoEmpadronamiento: solicitudSeleccionada.idTipoEmpadronamiento,
        medicamento: medicamento.medicamento
      };
    });

    medicamentosFormateados.forEach(medicamento => {
      if (medicamentosDeEmpadronamiento.filter(item => item.idMedicamento === medicamento.idMedicamento).length === 0) {
        medicamentosValidos = false;
        if (medicamento?.medicamento?.drogas.length > 40) {
          drogas = medicamento?.medicamento?.drogas.substring(0, 40) + "[...]";
        } else {
          drogas = medicamento?.medicamento?.drogas;
        }

        if (mensajeString !== "") {
          mensajeString = `${mensajeString}.\n El medicamento ${medicamento.medicamento?.presentacion} | ${medicamento.medicamento?.laboratorio} | ${medicamento?.medicamento?.nombre} | ${drogas}`;
        } else {
          mensajeString = "El medicamento " + medicamento.medicamento?.presentacion + " | " + medicamento.medicamento?.laboratorio + " | " + medicamento?.medicamento?.nombre + " | " + drogas;
        }
      }

    });

    //validar
    if (medicamentosValidos) {
      dispatch(postMedicamentosMedicacion({ medicamentos: medicamentosFormateados }, avanzarPantalla));
    } else {
      setMensaje(mensajeString + " no se encuentran en el empadronamiento ¿Desea continuar?");
      setOpen(true);
    }
  };

  console.log("medicamentos", medicamentos);

  return (
    <MedicacionCard width={"75%"}>
      <MedicacionAddMedicamento desdeIngreso={true} />
      {medicamentos.map((medicamento, index) => {
        return (
          <MedicacionMedicamento
            key={index}
            medicamento={medicamento}
            idTipoEmpadronamiento={solicitudSeleccionada?.empadronamientoSolicitud?.idTipoEmpadronamiento}
            desdeIngreso={true}
          />
        );
      })}
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: "3rem" }}
          onClick={() => {
            dispatch(setActiveStep(STEPPER_MEDICACION.DOCUMENTACION));
          }}
        >
          Anterior
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickSiguienteHandler}
        >
          Siguiente
        </Button>
      </div>
      {/*redirect && (
        <Redirect
          to={{
            pathname: "/autorizaciones",
          }}
        />
        )*/}
      {true
        &&
        <AlertaMedicamento
          open={open}
          setOpen={setOpen}
          mensaje={mensaje}
          handleDecisionYes={onConfirmHandler}
          handleDecisionNo={false}
        />}
    </MedicacionCard>
  );
};
